const pad2 = (n: number) => String(n).padStart(2, '0');

export const formatUtcDisplay = (iso?: string) => {
    if (!iso) return '--';
    const t = Date.parse(iso);
    if (!Number.isFinite(t)) return '--';
    const d = new Date(t);
    return `${d.getUTCFullYear()}-${pad2(d.getUTCMonth() + 1)}-${pad2(d.getUTCDate())} ${pad2(
        d.getUTCHours(),
    )}:${pad2(d.getUTCMinutes())}`;
};

export const toUtcMs = (iso?: string) => {
    if (!iso) return undefined;
    const t = Date.parse(iso);
    return Number.isFinite(t) ? t : undefined;
};

export const formatUtcToDDMMMYYYY = (iso?: string) => {
    if (!iso) return '--';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '--';
    const M = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    const dd = String(d.getUTCDate()).padStart(2, '0');
    const mmm = M[d.getUTCMonth()];
    const yyyy = d.getUTCFullYear();
    const hh = String(d.getUTCHours()).padStart(2, '0');
    const mm = String(d.getUTCMinutes()).padStart(2, '0');
    return `${dd}${mmm}${yyyy} ${hh}:${mm}`;
};
